export default {
  // Contractor Options
  CONTRACTOR_TYPES: [
    {
      key: 'general',
      value: 'General',
    },
    {
      key: 'carpenter',
      value: 'Carpenter',
    },
    {
      key: 'electrician',
      value: 'Electrician',
    },
    {
      key: 'drywaller',
      value: 'Drywaller',
    },
    {
      key: 'plastering',
      value: 'Plastering',
    },
    {
      key: 'painter',
      value: 'Painter',
    },
    {
      key: 'wallpaper-installer',
      value: 'Wallpaper Installer',
    },
    {
      key: 'hvac',
      value: 'Heating and Air-Conditioning (HVAC)',
    },
    {
      key: 'mason',
      value: 'Mason',
    },
    {
      key: 'roofer',
      value: 'Roofer',
    },
    {
      key: 'excavator',
      value: 'Excavator',
    },
    {
      key: 'demolition',
      value: 'Demolition',
    },
    {
      key: 'landscapers',
      value: 'Landscapers',
    },
    {
      key: 'concrete-specialist',
      value: 'Concrete Specialist',
    },
    {
      key: 'ironworker',
      value: 'Ironworker',
    },
    {
      key: 'steelworker',
      value: 'Steelworker',
    },
    {
      key: 'tile-setting',
      value: 'Tile Setting',
    },
    {
      key: 'floor-laying',
      value: 'Floor Laying',
    },
    {
      key: 'glass-and-glazing',
      value: 'Glass and Glazing',
    },
    {
      key: 'special-trade-contractors',
      value: 'Special Trade Contractors',
    },
  ],
  // Project Options
  PROPERTY_TYPES: [
    {
      key: 'condos',
      value: 'Condo',
    },
    {
      key: 'house',
      value: 'House',
    },
    {
      key: 'townhouse',
      value: 'Townhouse',
    },
    {
      key: 'apartment',
      value: 'Apartment',
    },
    {
      key: 'commercial',
      value: 'Commercial',
    },
    {
      key: 'other',
      value: 'Other',
    },
  ],
  SERVICE_TYPES: [
    {
      key: 'air-conditioning-installation',
      value: 'Air Conditioning Installation',
      locales: { en: 'Air Conditioning Installation', zh: '空调安装' },
    },
    {
      key: 'air-conditioning-repair',
      value: 'Air Conditioning Repair',
      locales: { en: 'Air Conditioning Repair', zh: '空调维修' },
    },
    {
      key: 'appliance-repair',
      value: 'Appliance Repair',
      locales: { en: 'Appliance Repair', zh: '家电维修' },
    },
    {
      key: 'appliances',
      value: 'Appliances',
      locales: { en: 'Appliances', zh: '家用电器' },
    },
    {
      key: 'basement-renovation',
      value: 'Basement Renovation',
      locales: { en: 'Basement Renovation', zh: '地下室装修' },
    },
    {
      key: 'basement-waterproofing',
      value: 'Basement Waterproofing',
      locales: { en: 'Basement Waterproofing', zh: '地下室补漏' },
    },
    {
      key: 'bathroom-renovation',
      value: 'Bathroom Renovation',
      locales: { en: 'Bathroom Renovation', zh: '浴室装修' },
    },
    {
      key: 'building-permit',
      value: 'Building Permit',
      locales: { en: 'Building Permit', zh: '建筑许可' },
    },
    {
      key: 'cabinet',
      value: 'Cabinet',
      locales: { en: 'Cabinet', zh: '橱柜浴柜' },
    },
    {
      key: 'central-humidifier',
      value: 'Central Humidifier',
      locales: { en: 'Central Humidifier', zh: '中央加湿器' },
    },
    {
      key: 'commercial-cleaning',
      value: 'Commercial Cleaning',
      locales: { en: 'Commercial Cleaning', zh: '商业清洁' },
    },
    {
      key: 'commercial-design',
      value: 'Commercial Design',
      locales: { en: 'Commercial Design', zh: '商业设计' },
    },
    {
      key: 'commercial-renovation',
      value: 'Commercial Renovation',
      locales: { en: 'Commercial Renovation', zh: '商业装修' },
    },
    {
      key: 'construction-builder',
      value: 'Construction Builder',
      locales: { en: 'Construction Builder', zh: '建筑施工' },
    },
    {
      key: 'countertops-processing',
      value: 'Countertops Processing',
      locales: { en: 'Countertops Processing', zh: '台面加工' },
    },
    {
      key: 'custom-build-design',
      value: 'Custom Build Design',
      locales: { en: 'Custom Build Design', zh: '房屋设计' },
    },
    {
      key: 'custom-build-home',
      value: 'Custom Build Home',
      locales: { en: 'Custom Build Home', zh: '加建重建' },
    },
    {
      key: 'custom-home-design',
      value: 'Custom Home Design',
      locales: { en: 'Custom Home Design', zh: '建房设计' },
    },
    {
      key: 'deck-fence',
      value: 'Deck & Fence',
      locales: { en: 'Deck & Fence', zh: '栅栏露台' },
    },
    {
      key: 'design-building-permit',
      value: 'Design & Building Permit',
      locales: { en: 'Design & Building Permit', zh: '设计与建筑许可' },
    },
    {
      key: 'door-window-glass',
      value: 'Door-Window Glass',
      locales: { en: 'Door-Window Glass', zh: '门窗玻璃' },
    },
    {
      key: 'draperies-shutters',
      value: 'Draperies & Shutters',
      locales: { en: 'Draperies & Shutters', zh: '窗帘布艺' },
    },
    {
      key: 'driveway-asphalt',
      value: 'Driveway Asphalt',
      locales: { en: 'Driveway Asphalt', zh: '车道沥青' },
    },
    {
      key: 'duct-cleaning',
      value: 'Duct Cleaning',
      locales: { en: 'Duct Cleaning', zh: '管道清洁' },
    },
    {
      key: 'electrical-building-materials',
      value: 'Electrical Building Materials',
      locales: { en: 'Electrical Building Materials', zh: '电器建材' },
    },
    {
      key: 'electrician',
      value: 'Electrician',
      locales: { en: 'Electrician', zh: '电工' },
    },
    {
      key: 'flooring-staircase',
      value: 'Flooring & Staircase',
      locales: { en: 'Flooring & Staircase', zh: '地板楼梯' },
    },
    {
      key: 'furnace-installtion',
      value: 'Furnace Installtion',
      locales: { en: 'Furnace Installtion', zh: '暖气安装' },
    },
    {
      key: 'furnace-repair',
      value: 'Furnace Repair',
      locales: { en: 'Furnace Repair', zh: '暖气维修' },
    },
    {
      key: 'garage-door',
      value: 'Garage Door',
      locales: { en: 'Garage Door', zh: '车库门' },
    },
    {
      key: 'handyservice',
      value: 'Handyservice',
      locales: { en: 'Handyservice', zh: '小修小补' },
    },
    {
      key: 'heating-air-conditioning',
      value: 'Heating & Air Conditioning',
      locales: { en: 'Heating & Air Conditioning', zh: '冷暖气' },
    },
    {
      key: 'home-addition',
      value: 'Home Addition',
      locales: { en: 'Home Addition', zh: '房屋加建' },
    },
    {
      key: 'home-inspection',
      value: 'Home Inspection',
      locales: { en: 'Home Inspection', zh: '验屋服务' },
    },
    {
      key: 'home-security',
      value: 'Home Security',
      locales: { en: 'Home Security', zh: '房屋防盗' },
    },
    {
      key: 'home-services',
      value: 'Home Services',
      locales: { en: 'Home Services', zh: '家居服务' },
    },
    {
      key: 'home-staging',
      value: 'Home Staging',
      locales: { en: 'Home Staging', zh: '软装设计' },
    },
    {
      key: 'house-cleaning',
      value: 'House Cleaning',
      locales: { en: 'House Cleaning', zh: '房屋清洁' },
    },
    {
      key: 'housekeeping',
      value: 'Housekeeping',
      locales: { en: 'Housekeeping', zh: '家政服务' },
    },
    {
      key: 'insulation',
      value: 'Insulation',
      locales: { en: 'Insulation', zh: '保温隔热' },
    },
    {
      key: 'interior-design',
      value: 'Interior Design',
      locales: { en: 'Interior Design', zh: '室内设计' },
    },
    {
      key: 'interior-projects',
      value: 'Interior Projects',
      locales: { en: 'Interior Projects', zh: '室内项目' },
    },
    {
      key: 'interior-renovation',
      value: 'Interior Renovation',
      locales: { en: 'Interior Renovation', zh: '室内装修' },
    },
    {
      key: 'irrigation-system',
      value: 'Irrigation System',
      locales: { en: 'Irrigation System', zh: '喷淋灌溉' },
    },
    {
      key: 'kitchen-remodeling',
      value: 'Kitchen Remodeling',
      locales: { en: 'Kitchen Remodeling', zh: '厨房装修' },
    },
    {
      key: 'land-survey',
      value: 'Land Survey',
      locales: { en: 'Land Survey', zh: '土地测量' },
    },
    {
      key: 'landscaping-design',
      value: 'Landscaping Design',
      locales: { en: 'Landscaping Design', zh: '园艺设计' },
    },
    {
      key: 'landscaping-interlocking',
      value: 'Landscaping & Interlocking',
      locales: { en: 'Landscaping & Interlocking', zh: '园艺铺砖' },
    },
    {
      key: 'lawn-care',
      value: 'Lawn Care',
      locales: { en: 'Lawn Care', zh: '园艺维护' },
    },
    {
      key: 'loan-service',
      value: 'Loan Service',
      locales: { en: 'Loan Service', zh: '贷款服务' },
    },
    {
      key: 'locksmith',
      value: 'Locksmith',
      locales: { en: 'Locksmith', zh: '门锁' },
    },
    {
      key: 'mold-removal',
      value: 'Mold Removal',
      locales: { en: 'Mold Removal', zh: '除霉菌' },
    },
    {
      key: 'moving-service',
      value: 'Moving Service',
      locales: { en: 'Moving Service', zh: '搬家服务' },
    },
    {
      key: 'others',
      value: 'Others',
      locales: { en: 'Others', zh: '其他服务' },
    },
    {
      key: 'outdoor-projects',
      value: 'Outdoor Projects',
      locales: { en: 'Outdoor Projects', zh: '室外项目' },
    },
    {
      key: 'outdoor-signs',
      value: 'Outdoor Signs',
      locales: { en: 'Outdoor Signs', zh: '户外招牌' },
    },
    {
      key: 'painting',
      value: 'Painting',
      locales: { en: 'Painting', zh: '油漆粉刷' },
    },
    {
      key: 'pest-control',
      value: 'Pest Control',
      locales: { en: 'Pest Control', zh: '杀虫除虫' },
    },
    {
      key: 'plumbing',
      value: 'Plumbing',
      locales: { en: 'Plumbing', zh: '水工' },
    },
    {
      key: 'pool-spa',
      value: 'Pool & Spa',
      locales: { en: 'Pool & Spa', zh: '室外泳池' },
    },
    {
      key: 'property-management',
      value: 'Property Management',
      locales: { en: 'Property Management', zh: '物业管理' },
    },
    {
      key: 'repair-maintenance',
      value: 'Repair & Maintenance',
      locales: { en: 'Repair & Maintenance', zh: '维修维护' },
    },
    {
      key: 'roofing',
      value: 'Roofing',
      locales: { en: 'Roofing', zh: '屋顶' },
    },
    {
      key: 'siding',
      value: 'Siding',
      locales: { en: 'Siding', zh: '建筑外墙' },
    },
    {
      key: 'smart-home',
      value: 'Smart Home',
      locales: { en: 'Smart Home', zh: '智能家居' },
    },
    {
      key: 'snow-removal',
      value: 'Snow Removal',
      locales: { en: 'Snow Removal', zh: '铲雪服务' },
    },
  ],
  // General Options
  GENERAL_SOURCES: [
    {
      key: 'Unknown',
      value: 'Unknown',
    },
    {
      key: 'Direct',
      value: 'Direct',
    },
    {
      key: 'HomeStars',
      value: 'HomeStars',
    },
    {
      key: 'Friend Referral',
      value: 'Friend Referral',
    },
    {
      key: 'Employee Referral',
      value: 'Employee Referral',
    },
    {
      key: 'Little Red Book',
      value: '小红书',
    },
    {
      key: 'Reno Assisstance',
      value: 'Reno Assisstance',
    },
    {
      key: 'Website',
      value: 'Website',
    },
    {
      key: 'WeChat',
      value: 'WeChat',
    },
    {
      key: 'Online Community',
      value: 'Online Community',
    },
    {
      key: 'Email',
      value: 'Email',
    },
    {
      key: 'SMS',
      value: 'SMS',
    },
    {
      key: 'Google Ads',
      value: 'Google Ads',
    },
    {
      key: 'Facebook Ads',
      value: 'Facebook Ads',
    },
    {
      key: 'Instagram Ads',
      value: 'Instagram Ads',
    },
    {
      key: 'Supermarket Ads',
      value: 'Supermarket Ads',
    },
    {
      key: 'Newspaper',
      value: 'Newspaper',
    },
    {
      key: 'Broadcast',
      value: 'Broadcast',
    },
    {
      key: 'Search Engine',
      value: 'Search Engine',
    },
    {
      key: '51.CA',
      value: '51.CA',
    },
    {
      key: 'Regular Customer',
      value: 'Regular Customer',
    },
    {
      key: 'Lawn Sign',
      value: 'Lawn Sign',
    },
    {
      key: 'Construction Site',
      value: 'Construction Site',
    },
  ],
  CUSTOMER_STATUS: [
    {
      key: 'pending',
      value: 'Pending',
    },
    {
      key: 'active',
      value: 'Active',
    },
    {
      key: 'inactive',
      value: 'Inactive',
    },
    {
      key: 'potential',
      value: 'Potential',
    },
    {
      key: 'interested',
      value: 'Interested',
    },
    {
      key: 'qualified',
      value: 'Qualified',
    },
    {
      key: 'not-interested',
      value: 'Not Interested',
    },
    {
      key: 'bad-fit',
      value: 'Bad Fit',
    },
  ],
  PROJECT_STATUS: [
    {
      key: 'pending',
      value: 'Pending',
      color: '#999999',
    },
    {
      key: 'contacted',
      value: 'Contacted',
      color: '#009900',
    },
    {
      key: 'quoted',
      value: 'Quoted',
      color: '#004fb6',
    },
    {
      key: 'confirmed',
      value: 'Confirmed',
      color: '#001fff',
    },
    {
      key: 'contracted',
      value: 'Contracted',
      color: '#176300',
    },
    {
      key: 'abandoned',
      value: 'Abandoned',
      color: '#ffae00',
    },
    {
      key: 'in_progress',
      value: 'In Progress',
      color: '#009900',
    },
    {
      key: 'rework',
      value: 'Rework',
      color: '#006600',
    },
    {
      key: 'inspected',
      value: 'Inspected',
      color: '#003300',
    },
    {
      key: 'ready_for_acceptance',
      value: 'Ready For Acceptance',
      color: '#003333',
    },
    {
      key: 'completed',
      value: 'Completed',
      color: '#004fb6',
    },
    {
      key: 'incomplete',
      value: 'Incomplete',
      color: '#990000',
    },
    {
      key: 'cancelled',
      value: 'Cancelled',
      color: '#000000',
    },
  ],
  DEPARTMENT: [
    {
      key: 'admin',
      value: 'Administration',
    },
    {
      key: 'editorial',
      value: 'Editorial',
    },
    {
      key: 'production',
      value: 'Production',
    },
    {
      key: 'sales',
      value: 'Sales',
    },
    {
      key: 'marketing',
      value: 'Marketing',
    },
    {
      key: 'tech',
      value: 'Technology',
    },
    {
      key: 'accounting',
      value: 'Accounting',
    },
    {
      key: 'finance',
      value: 'Finance',
    },
    {
      key: 'hr',
      value: 'H&R',
    },
  ],
  JOB_TITLES: [
    {
      key: 'administrator',
      value: 'Administrator',
    },
    {
      key: 'accountant',
      value: 'Accountant',
    },
    {
      key: 'architect',
      value: 'Architect',
    },
    {
      key: 'analyst',
      value: 'Analyst',
    },
    {
      key: 'assistant',
      value: 'Assistant',
    },
    {
      key: 'associate',
      value: 'Associate',
    },
    {
      key: 'coordinator',
      value: 'Coordinator',
    },
    {
      key: 'consultant',
      value: 'Consultant',
    },
    {
      key: 'director',
      value: 'Director',
    },
    {
      key: 'developer',
      value: 'Developer',
    },
    {
      key: 'designer',
      value: 'Designer',
    },
    {
      key: 'executive',
      value: 'Executive',
    },
    {
      key: 'engineer',
      value: 'Engineer',
    },
    {
      key: 'entry',
      value: 'Entry',
    },
    {
      key: 'general_manager',
      value: 'General Manager',
    },
    {
      key: 'head',
      value: 'Head',
    },
    {
      key: 'professional',
      value: 'Professional',
    },
    {
      key: 'president',
      value: 'President',
    },
    {
      key: 'principal',
      value: 'Principal',
    },
    {
      key: 'manager',
      value: 'Manager',
    },
    {
      key: 'scientist',
      value: 'Scientist',
    },

    {
      key: 'specialist',
      value: 'Specialist',
    },
    {
      key: 'strategist',
      value: 'Strategist',
    },
    {
      key: 'supervisor',
      value: 'Supervisor',
    },
    {
      key: 'officer',
      value: 'Officer',
    },
    {
      key: 'operator',
      value: 'Operator',
    },
  ],
  CAMPAIGN_STATUS: [
    {
      key: 'draft',
      value: 'Draft',
      color: '#aaaaaa',
    },
    {
      key: 'scheduled',
      value: 'Scheduled',
      color: '#009900',
    },
    {
      key: 'sending',
      value: 'Sending',
      color: '#003388',
    },
    {
      key: 'sent',
      value: 'Sent',
      color: '#00cc00',
    },
    {
      key: 'interrupted',
      value: 'Interrupted',
      color: '#00cc00',
    },
    {
      key: 'cancelled',
      value: 'Cancelled',
      color: '#bb0000',
    },
  ],
  LOCALES: [
    {
      key: 'en-US',
      value: 'English',
    },
    {
      key: 'zh-CN',
      value: 'Chinese',
    },
    {
      key: 'fr-FR',
      value: 'French',
    },
  ],
}
